<div class="wrapper-landing-page">
    <div class="section-main">
        <div class="container-xl">
            <div class="row">
                <div class="section-text col-12 col-sm-12 col-md-6">
                    <h1 class="title">
                        BUILD YOUR ONLINE BUSINESS EMPIRE
                        <span class="text-blue"> WITH US</span>
                    </h1>
                    <p class="subtitle">
                        You can now setup the perfect eStore without hassle and enjoy your profitable growth.
                    </p>
                    <div class="section-btn">
                        <button (click)="goToSignUp()" class="btn btn-create rounded-pill">
                            Setup New Store
                        </button>
                    </div>
                </div>
                <div class="section-image col-12 col-sm-12 col-md-6">
                    <img class="hero-image" src="https://cdn.estore5s.com/asset/images/hero-image.png" alt="hero">
                </div>
            </div>
        </div>
    </div>
    <div class="bg-curve"></div>
</div>